var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import "./VirtualRenderStyle.scss";
var VirtualRenderComponent = /** @class */ (function () {
    function VirtualRenderComponent(options) {
        this.State = { scrollPos: 0 };
        var defaultOptions = {
            data: null,
            renderRow: null,
            bufferSizeInPx: 200,
            rowHeight: 20,
            rowTag: "div",
            viewportSizeInPX: window.innerHeight
        };
        this.options = __assign(__assign({}, defaultOptions), options);
    }
    VirtualRenderComponent.prototype.isEqual = function (node) {
        return this.__proto__ === node.__proto__;
    };
    VirtualRenderComponent.prototype.setData = function (data) {
        this.options.data = data;
    };
    VirtualRenderComponent.prototype.onInit = function (renderer) {
        this.State.renderer = renderer;
    };
    VirtualRenderComponent.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var o = this.options;
        var vrBody = {
            tag: "div",
            attr: { class: "v-r-child", style: "height:" + (o.data.length * o.rowHeight) + "px;position:relative" },
            children: this.getChildren()
        };
        var vrContainer = {
            tag: "div", attr: {
                class: "v-r-comp " + ((_a = o.class) !== null && _a !== void 0 ? _a : ""),
                style: "overflow-y:auto;" + ((_b = o.style) !== null && _b !== void 0 ? _b : ""),
                scroll: function (e, node) {
                    var newScrollPos = node.dom.scrollTop;
                    if (Math.abs(_this.State.scrollPos - newScrollPos) < o.bufferSizeInPx) {
                        return false;
                    }
                    _this.State.scrollPos = newScrollPos;
                    vrBody.children = _this.getChildren();
                    node.children[0].children = [{ tag: "dummy" }];
                    _this.State.renderer.updateNode(node.children[0], vrBody);
                    return false;
                }
            }, children: [vrBody]
        };
        return vrContainer;
    };
    // public scrollRowToTop(idx: number) {
    // }
    // public scrollRowToCenter(idx: number) {
    // }
    // public scrollRowToBottom(idx: number) {
    // }
    VirtualRenderComponent.prototype.getChildren = function () {
        var o = this.options;
        var children = [];
        var viewport = {
            top: Math.floor((this.State.scrollPos - o.bufferSizeInPx) / o.rowHeight),
            bottom: Math.ceil((this.State.scrollPos + o.viewportSizeInPX + o.bufferSizeInPx) / o.rowHeight)
        };
        for (var idx = viewport.top; idx < viewport.bottom; idx++) {
            if (idx < 0 || idx >= o.data.length) {
                continue;
            }
            var node = {
                tag: o.rowTag, attr: {
                    style: {
                        top: (idx * o.rowHeight) + "px",
                        height: o.rowHeight + "px",
                        position: "absolute",
                        left: "0",
                        right: "0"
                    }
                }, children: []
            };
            var result = o.renderRow({ index: idx, container: node, rowData: o.data[idx] });
            if (typeof result === "string") {
                node.content = result;
            }
            else if (result != null) {
                node.children.push(result);
            }
            children.push(node);
        }
        return children;
    };
    return VirtualRenderComponent;
}());
export { VirtualRenderComponent };
